import { inject, Injectable } from '@angular/core';
import { clamp, isEqual } from 'lodash';
import { isOrthographicVideoOutput } from '../../../../cross-team-shared/misc-utils/output-utils';
import { Dimensions } from '../../../../cross-team-shared/types/misc';
import { shellConnectorToken } from '../../../../team-apis/core/shell-connector';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { AbstractSensorContentStore2D } from '../../state/abstract-sensor-content-store-2d';

@Injectable()
export class ImageBoundsService {
  store = inject(AbstractSensorContentStore2D);
  shellConnector = inject(shellConnectorToken);

  snapToImage(point: Point2D = this.store.state().mouse.imagePoint): Point2D {
    if (isOrthographicVideoOutput(this.store.state().output)) {
      return point;
    }
    const { pixelSize } = this.store.state();
    const imageSize = this.store.state().sensorRendererState;
    const { topLeft, bottomRight } = this.calculateImageBounds(imageSize);
    return [
      clamp(point[0], topLeft[0], bottomRight[0] - pixelSize),
      clamp(point[1], topLeft[1], bottomRight[1] - pixelSize),
    ];
  }

  isInBounds(point: Point2D): boolean {
    return (
      this.shellConnector.hasFeatureFlag('out-of-bounds-editing') ||
      isEqual(point, this.snapToImage(point))
    );
  }

  boundPoints(point: Point2D = this.store.state().mouse.imagePoint) {
    if (this.shellConnector.hasFeatureFlag('out-of-bounds-editing')) {
      return point;
    }
    return this.snapToImage(point);
  }

  private calculateImageBounds(imageSize: Dimensions) {
    const { clampOffset } = this.store.state().sensorRendererState;
    const topLeft = [clampOffset[0], clampOffset[1]];
    const bottomRight = [
      imageSize.width + clampOffset[0],
      imageSize.height + clampOffset[1],
    ];
    return { topLeft, bottomRight };
  }
}
